
// Test data for Level 1 Wedging Training

export const wedgingTests = [
  {
    id: "wedging-cercles",
    title: "Wedging court",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 1, 3, 5 m. Taper 10 balles depuis les distances G=60, H=80, I=100 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-pente-gauche",
    title: "Wedging court en pente gauche droite",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 1, 3, 5 m. Placer sa balle dans une pente gauche droite, taper 10 balles depuis les distances G1=60, H1=80, I1=100 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  },
  {
    id: "wedging-mid",
    title: "Wedging mi-distance",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 1, 3, 5 m. Taper 10 balles depuis les distances G2=75, H2=85, I2=95 et compter les points selon le cercle d'arrivée.",
    icon: "🏌️"
  }
];
